
import MapOverlay from '@/components/MapOverlay.vue'
import PronosticoMeteorologicoFooter from '@/components/PronosticoMeteorologicoFooter.vue'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { Action, State } from 'vuex-class'
import { PronosticoMeteorologicoState } from '@/store/modules/pronostico-meteorologico/types'
import { createArray } from '@/components/helpers/timelineArray'
import { validateImageType } from '@/components/helpers/setPronosticoMeteorologicoOverlay'
import DesktopFooter from '@/components/DesktopFooter.vue'
import { preloadImages } from '@/components/helpers/preloadImages'
import { getEnvironments } from '@/environments'
const env = getEnvironments()

const PRONOSTICO_METEOROLOGICO = 'pronosticoMeteorologico'
const GOOGLE_MAPS_MODULE = 'googleMaps'

@Component({
  components: {
    MapOverlay,
    DesktopFooter,
    PronosticoMeteorologicoFooter
  }
})
export default class PronosticoMeteorologico extends Vue {
  @State(PRONOSTICO_METEOROLOGICO)
  public pronosticoMeteorologico!: PronosticoMeteorologicoState | any
  @Action('getPronosticoMeteorologico', { namespace: PRONOSTICO_METEOROLOGICO })
  private getPronosticoMeteorologico: any
  @Action('setOverlayViews', { namespace: GOOGLE_MAPS_MODULE })
  private setOverlayViews: any
  @Action('setPosition', { namespace: GOOGLE_MAPS_MODULE })
  private setPosition: any
  @Prop() type!: string
  @Prop() vector!: string
  private timelineList: any[] = []
  private currentPosition: number = 0
  private baseImageUrl: string = env.url.IMG

  get computedTimelineList () {
    if (this.pronosticoMeteorologico.delta > 0) this.timelineList = createArray(this.pronosticoMeteorologico)
    return this.timelineList
  }

  setOverlays ({ position }: { position: number }) {
    if (validateImageType(this.type) && this.pronosticoMeteorologico.pasos > 0) {
      const overlays: any[] = []
      const currentItem = position
      const { ruta, latlong, imagenes } = this.pronosticoMeteorologico
      const bounds = {
        south: latlong[0][0],
        north: latlong[1][0],
        west: latlong[0][1],
        east: latlong[1][1]
      }

      imagenes[this.type].forEach((image: string, index: number) => {
        const srcImage = `${this.baseImageUrl}${ruta}/${image}`

        overlays.push({
          bounds,
          image: srcImage,
          isShown: currentItem === index
        })
        if (this.vector) {
          const vectorImage = imagenes['VectoresViento'][index]
          const vectorSrcImage = `${this.baseImageUrl}${ruta}/${vectorImage}`
          overlays.push({
            bounds,
            image: vectorSrcImage,
            isShown: currentItem === index
          })
        }
      })
      this.currentPosition = currentItem
      this.setOverlayViews(overlays)
    }
  }

  getData () {
    // Get the data from the store
    return this.getPronosticoMeteorologico()
  }

  async created () {
    await this.getData()
    preloadImages(this.baseImageUrl, this.pronosticoMeteorologico)
    const position = {
      lat: this.pronosticoMeteorologico.centro[0],
      lng: this.pronosticoMeteorologico.centro[1]
    }
    const zoom = env.settings.PRONOSTICO_METEOROLOGICO.zoom
    this.setPosition({ position, zoom })
  }

  beforeDestroy () {
    this.setOverlayViews([])
  }
}
